const apiFetch = async (url, options = {}) => {
  let response;

  try {
    response = await fetch(url, options);
  } catch (err) {
    console.error(err);
    throw new Error("Network error. Please check your connection.");
  }

  // console.log("Request URL:", response.url);
  // console.log("Status:", response.status);
  // console.log("Content-Type:", response.headers.get("content-type"));

  const text = await response.clone().text();
  // console.log("Response:", text.substring(0, 500));

  if (response.status === 531) {
    throw new Error("Session expired. Please login again.");
  }

  if (!response.ok) {
    throw new Error(text);
  }

  return response;
};

export default apiFetch;